/**
 * VAPID-ключ: `config.push.vapid_public_key` приходит в base64url
 * (несжатая точка P-256, 65 байт), а `PushManager.subscribe` принимает
 * `BufferSource` (CLIENT_WEB.md §8.2 п. 1).
 *
 * Обратное преобразование нужно для сверки ключа активной подписки с
 * конфигурацией при каждом запуске (§8.2 п. 3, CC §9.7 п. 3, решение D-38):
 * браузер отдаёт `subscription.options.applicationServerKey` как ArrayBuffer.
 */

/** base64url → байты. Бросает, если строка не разбирается. */
export function base64UrlToBytes(value: string): Uint8Array {
  const padding = '='.repeat((4 - (value.length % 4)) % 4)
  const base64 = (value + padding).replace(/-/g, '+').replace(/_/g, '/')
  const binary = atob(base64)

  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i)
  return bytes
}

/** байты → base64url без выравнивающих `=`. */
export function bytesToBase64Url(buffer: ArrayBuffer | ArrayBufferView): string {
  const bytes =
    buffer instanceof ArrayBuffer
      ? new Uint8Array(buffer)
      : new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength)

  let binary = ''
  for (const byte of bytes) binary += String.fromCharCode(byte)

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

/**
 * Сверка ключа подписки с конфигурацией.
 *
 * `options.applicationServerKey` поддержан не везде; когда его нет, сверять
 * нечем — подписка считается совпадающей, иначе клиент переподписывался бы
 * при каждом запуске и терял бы уже работающий endpoint.
 */
export function subscriptionKeyMatches(subscription: PushSubscription, expected: string): boolean {
  const raw = subscription.options?.applicationServerKey
  if (!raw) return true

  try {
    return bytesToBase64Url(raw) === expected.replace(/=+$/, '')
  } catch {
    return true
  }
}
